export default __webpack_public_path__ + "xara.7b4ebf82.png";